// extracted by mini-css-extract-plugin
module.exports = {"root":"CategoryService_root__1WeuZ","label":"CategoryService_label__sfBv8","location":"CategoryService_location__8bKwy"};